<template>
<!--  <div class="login-form">-->
  <b-card-group deck align="center">
      <b-card style="max-width: 20rem;">
      <b-card-text>
        <form @submit.prevent="login">
          <div>
            <b-input type="text" name="email" v-model="form.email" placeholder="Email"/>
            <b-input type="password" name="password" v-model="form.password" placeholder="Пароль"/>
          </div>
        </form>
        <p class="alert-danger" v-if="$store.state.login_error" id="error">{{$store.state.login_error}}</p>
      </b-card-text>
        <b-button variant="success" type="submit" @click.prevent.stop="login">Войти</b-button>
        <b-button variant="dark" to="/signin">Регистрация</b-button>
        <router-link class="small" variant="primary" to="/restore">Забыли пароль?</router-link>
      </b-card>
    </b-card-group>
</template>

<script>

export default {
  name: "LoginView",
  components: {},
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      showError: false
    };
  },
  methods: {
    login: function (){
      this.$store.dispatch('authRequest',
          {'username': this.form.email, 'password': this.form.password})
    }
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 10px;
}

/*label {*/
/*  padding: 12px 12px 12px 0;*/
/*  display: inline-block;*/
/*}*/

/*button[type="submit"] {*/
/*  background-color: #4caf50;*/
/*  color: white;*/
/*  padding: 12px 20px;*/
/*  cursor: pointer;*/
/*  border-radius: 30px;*/
/*}*/

/*button[type="submit"]:hover {*/
/*  background-color: #45a049;*/
/*}*/

/*input {*/
/*  margin: 5px;*/
/*  box-shadow: 0 0 15px 4px rgba(0, 0, 0, 0.06);*/
/*  padding: 10px;*/
/*  border-radius: 30px;*/
/*}*/

form {
  max-width: 300px;
}

#error {
  color: red;
}
</style>
